// alternative-dashboard\dashboardWidgetRegistryConfig\compactWidgetRegistry.config.ts
import type { DashboardWidgetRegistry } from "../DashboardWidgetRenderer";
import AccountsWidget from "../alternative-components/compactWidgetsCardDetails/AccountsWidget";
import ApprovalRequiredCompactWidget from "../alternative-components/compactWidgetsCardDetails/ApprovalRequiredCompactWidget";
import CashTrendWidgets from "../alternative-components/compactWidgetsCardDetails/CashTrendWidgets";
import RepairQueueCard from "../alternative-components/compactWidgetsCardDetails/RepairQueueCard";
import QuickActionsWidget from "../alternative-components/compactWidgetsCardDetails/QuickActionsWidget";
import RecentTransactionPanel from "../alternative-components/approval/RecentTransactionPanel";

export const COMPACT_SUMMARY_MENU_IDS = new Set([61, 62, 63, 215]);

export const COMPACT_WIDGET_REGISTRY: DashboardWidgetRegistry = {
  202: AccountsWidget, // Accounts
  66: ApprovalRequiredCompactWidget, // Approvals
  217: CashTrendWidgets, // Cash Trend
  206: RepairQueueCard, // Repair Queue
  204: QuickActionsWidget, // Quick Actions Grid
  64: RecentTransactionPanel, // Recent Repair Transactions
};
